import { Mask } from '@/types';
import { masker } from './masker';
import { monetaryFormat, monetaryUnformat } from './monetary';
import { MonetaryOptions } from './types';

const makeMaskResult = (unmaskedValue: string, maskedValue?: string) => ({
  unmaskedValue: unmaskedValue ?? '',
  value: maskedValue ?? unmaskedValue ?? '',
});

export const useMask =
  (masks: Mask, monetary: boolean | Partial<MonetaryOptions> = false) =>
  (value: string) => {
    if (!masks.length && !monetary) return makeMaskResult(value);

    if (monetary) {
      const options = typeof monetary !== 'boolean' ? monetary : undefined;
      const maskedValue = monetaryFormat(value, options);
      const unmaskedValue = monetaryUnformat(maskedValue, options?.precision);
      return makeMaskResult(unmaskedValue, maskedValue);
    }

    const maskedValue = masker(value, masks, true);
    const unmaskedValue = masker(maskedValue, masks, false);
    return makeMaskResult(unmaskedValue, maskedValue);
  };
